<div class="content-with-filled-button">
    <h2 class="sub-title offset-inline" id="generalTitle">
        {{copyService.copies.request_loan_subtitle}}
    </h2>
    <br>
    <div class="checkbox">
        <voxel-radio-button-group>
            <voxel-radio-button *ngFor="let selectionList of listRequestLoan"
                [id]="'radioButtonID' + selectionList.elementId" radioName="loan" [checked]="selectionList.checked"
                (radioButtonChange)="selectRequestLoan(selectionList)" [value]="selectionList.elementId">
                {{selectionList.description}}
            </voxel-radio-button>
        </voxel-radio-button-group>
    </div>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.agreement_filter_next_button"
    [nextDisabled]="isBtnDisabled" (next)="next()"></app-controls>